export default {
    created(){
      if(!this.getCategories || this.getCategories.length === 0) {
          this.$store.dispatch('fetchCategories')
      }
    },
    computed: {
        getCategories() {
            return this.$store.getters.getCategories
        },
        getItemsCategories() {
            return this.$store.getters.getCategories.filter(category => this.hasCategoryItems(category))
        },
        getItemsByCategory() {
            return category => {
                return this.items.filter(i => i.category.id === category.id)
            }
        },
        getItemsQuantityByCategory() {
            return category => {
                return this.getItemsByCategory(category).reduce( (a,v)=> a+v.quantity,0)
            }
        },
        hasCategoryItems() {
            return category => {
                if (category && category.id) {
                    return this.items.some(i => i.category.id === category.id)
                }
            }
        }
    },
}
